<app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>

<div class="container ">
    <div class="row">
        <div class="col-md-3 ">
            <div class="mb-1 fw-bold">
                <label>Buscar por</label>
            </div>
            <div class="input-group">
                <span class="input-group-text fondo-blanco color-gris cursor" (click)="buscar(texto.value)"><i
                        class="fa-solid fa-magnifying-glass"></i></span>
                <input type="text" class="form-control lineas-buscadores" placeholder="Nombre Funcionario" #texto id="caja">
                <span class="input-group-text fondo-blanco color-gris cursor" (click)="borrar()" id="cancel">
                    <i class="fa-solid fa-circle-xmark"></i>
                </span>
            </div>
        </div>
    </div>
    <div class="row justify-content-center mt-3">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2" aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr class="text-center">
                        <th scope="col-3">Nombre funcionario</th>
                        <th scope="col-3">Nombre usuario</th>
                        <th scope="col-2">Cargo</th>
                        <th scope="col-2">Área</th>
                        <th scope="col-2">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let usuario of usuarios | paginate: { itemsPerPage: 20, currentPage: pagina }"
                        class="text-center">
                        <td >{{ usuario.nombreUsuario }}</td>
                        <td >{{ usuario.email }}</td>
                        <td >{{ usuario.perfil }}</td>
                        <td >{{ usuario.area }}</td>
                        <td >
                            <a class="text-primary cursor me-3"
                                [routerLink]="['cons-func-rol-usu', usuario.idUsuario]"><i
                                    class="fa fa-eye fa-lg"></i></a>
                            <a class="text-primary cursor me-3"
                                [routerLink]="['asig-func-rol-usu', usuario.idUsuario]"><i
                                    class="fa fa-marker fa-lg"></i></a>

                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
                <pagination-controls class="clase-paginador" (pageChange)="pagina = $event" previousLabel="Anterior"
                    nextLabel="Siguiente"></pagination-controls>
            </div>
        </div>
    </div>
</div>
